import React from 'react';
import './Card.css';

/**
 * Modern Card Component
 * 
 * @param {boolean} hoverable - Adds hover effect
 * @param {boolean} glass - Adds glassmorphism effect
 * @param {boolean} padded - Adds default padding
 */
const Card = ({ 
  children, 
  className = '', 
  hoverable = false, 
  glass = false,
  padded = true,
  ...props 
}) => {
  const classes = [
    'ui-card',
    hoverable ? 'ui-card--hoverable' : '',
    glass ? 'ui-card--glass' : '',
    padded ? 'ui-card--padded' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={`ui-card__header ${className}`}>{children}</div>
);

export const CardBody = ({ children, className = '' }) => (
  <div className={`ui-card__body ${className}`}>{children}</div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={`ui-card__footer ${className}`}>{children}</div>
);

export default Card;
